import { combineReducers } from 'redux';

import groupsReducer from "./groupsReducer";
import productReducer from "./productReducer";
import productFilterReducer from "./productFilterReducer";
import productDataReducer from "./productDataReducer";


export default combineReducers({
    groupsState: groupsReducer,
    productsState: productReducer,
    productFilterState: productFilterReducer,
    productState: productDataReducer,
});
